module.exports = __webpack_public_path__ + "static/media/main-hero-2022jpg.e8ca55af.jpg";